var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _circle3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _circle4, _path59, _path60;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUndrawConnect = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Group 92",
  viewBox: "0 0 785.166 507.754"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 562",
  d: "M548.006 342.431c-80.774 0-151.053-60.252-161.435-142.437l1.984-.251c10.254 81.171 79.677 140.684 159.452 140.689a161.345 161.345 0 0020.268-1.279c87.991-11.116 150.53-91.74 139.414-179.726l1.984-.251c11.253 89.08-52.063 170.708-141.143 181.96a163.741 163.741 0 01-20.524 1.295z",
  fill: "#3f3d56"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 563",
  d: "M612.417 80.638a56.086 56.086 0 11104.916-39.687l-1.871.708A54.085 54.085 0 00614.288 79.93z",
  fill: "#3f3d56"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 564",
  d: "M774.889 178.53H673.224a10.288 10.288 0 01-10.277-10.277V33.637a10.288 10.288 0 0110.277-10.277h101.665a10.288 10.288 0 0110.277 10.277v134.616a10.288 10.288 0 01-10.277 10.277z",
  fill: "#e6e6e6"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 565",
  d: "M734.496 170.464h-54.125a9.636 9.636 0 01-9.625-9.625V41.05a9.636 9.636 0 019.625-9.624h87.372a9.635 9.635 0 019.625 9.625v86.543a42.92 42.92 0 01-42.872 42.871z",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 566",
  d: "M759.027 91.498h-69.944a2.281 2.281 0 010-4.562h69.94a2.281 2.281 0 010 4.562z",
  fill: "#e4e4e4"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 567",
  d: "M759.027 100.511h-69.944a2.281 2.281 0 110-4.562h69.94a2.281 2.281 0 110 4.562z",
  fill: "#e4e4e4"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 568",
  d: "M719.404 109.525h-30.321a2.281 2.281 0 110-4.562h30.318a2.281 2.281 0 110 4.562z",
  fill: "#e4e4e4"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 569",
  d: "M759.027 54.69h-69.944a2.281 2.281 0 110-4.562h69.94a2.281 2.281 0 010 4.562z",
  fill: "#e4e4e4"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 570",
  d: "M759.027 63.703h-69.944a2.281 2.281 0 110-4.562h69.94a2.281 2.281 0 110 4.562z",
  fill: "#e4e4e4"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 571",
  d: "M719.404 72.717h-30.321a2.281 2.281 0 010-4.562H719.4a2.281 2.281 0 110 4.562z",
  fill: "#e4e4e4"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 572",
  d: "M759.027 129.594h-69.944a2.281 2.281 0 010-4.562h69.94a2.281 2.281 0 110 4.562z",
  fill: "#6cbbed"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 573",
  d: "M700.027 138.607h-10.944a2.281 2.281 0 110-4.562h10.94a2.281 2.281 0 110 4.562z",
  fill: "#6cbbed"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 574",
  d: "M719.404 147.621h-30.321a2.281 2.281 0 110-4.562h30.318a2.281 2.281 0 110 4.562z",
  fill: "#6cbbed"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 575",
  d: "M388.083 174.017a94.032 94.032 0 01175.9-66.54l-1.871.708a92.031 92.031 0 10-172.156 65.122z",
  fill: "#3f3d56"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 82",
  cx: 9.546,
  cy: 9.546,
  r: 9.546,
  transform: "translate(553.361 1.595)",
  fill: "#ffb5e2"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 83",
  cx: 9.546,
  cy: 9.546,
  r: 9.546,
  transform: "translate(566.361 276.595)",
  fill: "#cbbbe0"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 84",
  cx: 9.546,
  cy: 9.546,
  r: 9.546,
  transform: "translate(321.361 49.595)",
  fill: "#b8def6"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 576",
  d: "M462.7 451.388H244.167a22.115 22.115 0 01-22.09-22.09V139.935a22.115 22.115 0 0122.09-22.09H462.7a22.115 22.115 0 0122.09 22.09v289.363a22.115 22.115 0 01-22.09 22.09z",
  fill: "#e6e6e6"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 577",
  d: "M379.292 433.477H259.528a20.137 20.137 0 01-20.114-20.114V155.87a20.137 20.137 0 0120.114-20.114h187.811a20.136 20.136 0 0120.114 20.114v189.447a88.26 88.26 0 01-88.16 88.16z",
  fill: "#fff"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 578",
  d: "M428.604 185.19h-150.34a4.903 4.903 0 010-9.806h150.34a4.903 4.903 0 010 9.806z",
  fill: "#6cbbed"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 579",
  d: "M428.604 204.564h-150.34a4.904 4.904 0 110-9.807h150.34a4.904 4.904 0 010 9.807z",
  fill: "#6cbbed"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 580",
  d: "M343.432 223.939h-65.168a4.904 4.904 0 010-9.807h65.169a4.904 4.904 0 010 9.807z",
  fill: "#6cbbed"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 581",
  d: "M428.604 264.516h-150.34a4.903 4.903 0 010-9.806h150.34a4.903 4.903 0 110 9.806z",
  fill: "#e4e4e4"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 582",
  d: "M428.604 283.891h-150.34a4.904 4.904 0 010-9.807h150.34a4.904 4.904 0 010 9.807z",
  fill: "#e4e4e4"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 583",
  d: "M343.432 303.265h-65.168a4.904 4.904 0 010-9.807h65.169a4.904 4.904 0 010 9.807z",
  fill: "#e4e4e4"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 584",
  d: "M428.604 343.843h-150.34a4.903 4.903 0 010-9.806h150.34a4.903 4.903 0 010 9.806z",
  fill: "#e4e4e4"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 585",
  d: "M428.604 363.217h-150.34a4.904 4.904 0 010-9.807h150.34a4.904 4.904 0 010 9.807z",
  fill: "#e4e4e4"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 586",
  d: "M343.432 382.592h-65.168a4.904 4.904 0 010-9.807h65.169a4.904 4.904 0 010 9.807z",
  fill: "#e4e4e4"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 587",
  d: "M631.076 236.53h-110.67a11.2 11.2 0 01-11.187-11.187V78.803a11.2 11.2 0 0111.187-11.187h110.67a11.2 11.2 0 0111.187 11.187v146.54a11.2 11.2 0 01-11.187 11.187z",
  fill: "#e6e6e6"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 588",
  d: "M590.05 227.706h-61.867a10.445 10.445 0 01-10.431-10.429v-130.4a10.445 10.445 0 0110.431-10.437h95.111a10.445 10.445 0 0110.435 10.437v97.153a43.729 43.729 0 01-43.68 43.679z",
  fill: "#fff"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 589",
  d: "M613.808 101.721h-76.135a2.483 2.483 0 010-4.966h76.135a2.483 2.483 0 010 4.966z",
  fill: "#e4e4e4"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 590",
  d: "M613.808 111.533h-76.135a2.483 2.483 0 110-4.966h76.135a2.483 2.483 0 010 4.966z",
  fill: "#e4e4e4"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 591",
  d: "M570.676 121.345h-33a2.483 2.483 0 010-4.966h33a2.483 2.483 0 110 4.966z",
  fill: "#e4e4e4"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 592",
  d: "M613.808 141.894h-76.135a2.483 2.483 0 010-4.966h76.135a2.483 2.483 0 010 4.966z",
  fill: "#6cbbed"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 593",
  d: "M593.808 151.706h-56.135a2.483 2.483 0 110-4.966h56.135a2.483 2.483 0 010 4.966z",
  fill: "#6cbbed"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 594",
  d: "M570.676 161.517h-33a2.483 2.483 0 010-4.966h33a2.483 2.483 0 110 4.966z",
  fill: "#6cbbed"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 595",
  d: "M613.808 182.067h-76.135a2.483 2.483 0 010-4.966h76.135a2.483 2.483 0 010 4.966z",
  fill: "#e4e4e4"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 596",
  d: "M613.808 191.877h-76.135a2.483 2.483 0 110-4.966h76.135a2.483 2.483 0 110 4.966z",
  fill: "#e4e4e4"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 597",
  d: "M570.676 201.69h-33a2.483 2.483 0 110-4.966h33a2.483 2.483 0 010 4.966z",
  fill: "#e4e4e4"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 598",
  d: "M129.395 286.877a8.566 8.566 0 00-1.708-13.024l7.02-29.621-14.858 5.428-4.389 27.3a8.613 8.613 0 0013.935 9.917z",
  fill: "#ffb8b8"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 599",
  d: "M165.127 162.748l-5.963 15.329s2.556 15.334-1.7 18.741-2.556 3.408-2.556 5.963a13.1 13.1 0 01-5.111 9.371c-3.408 2.556-18.741 54.52-18.741 54.52h-15.338a48.041 48.041 0 000-11.926c-.852-5.963 2.556-21.3 4.259-23.852s0-5.963 0-11.074 3.408-7.667 3.408-16.186 10.222-74.965 9.371-82.632 8.519-14.482 8.519-14.482h8.519z",
  fill: "#6cbbed"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 600",
  d: "M201.206 195.271l16.69 63.016-93.34-5.416 24.7-62.117z",
  fill: "#2f2e41"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 601",
  d: "M3.235 432.994a96.9 96.9 0 0012.51 27.53c12.48 18.87 30.34 33.3 49.97 44.85 1.36.81 2.74 1.6 4.12 2.38h13.77l.48-1.1v-.01l.56-1.27.07-.15.03.15.55 2.38h6.76c.56-.79 1.11-1.58 1.65-2.38.79-1.17 1.55-2.35 2.27-3.55a57.644 57.644 0 003.4-6.52c.12-.25.22-.5.32-.75l-.45-.49 1.87-8.18-3.76-.62 4.12-12.71c-.15-.47-.32-.94-.5-1.41-2.31-5.85-6.65-10.22-11.8-13.89-5.3-3.79-11.47-6.83-17.14-9.99a137.71 137.71 0 01-7.83-4.72v-.01q-4.89-3.165-9.49-6.77a1.428 1.428 0 01-.15-.11 1.081 1.081 0 01-.12-.1 140.9 140.9 0 01-34.31-38.93.01.01 0 01-.01-.01c-.3-.48-.58-.96-.86-1.45v-.01a136.252 136.252 0 01-9.41-19.65v-.01c-.2-.5-.38-1-.57-1.5q-.39.66-.75 1.32a.01.01 0 00-.01.01c-9.7 17.353-10.62 38.253-5.29 57.67z",
  fill: "#f0f0f0"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 602",
  d: "M8.525 375.324a121.364 121.364 0 002.87 27.54 118.547 118.547 0 003.36 12.24 121.348 121.348 0 0010.13 22.6c.23.39.45.77.69 1.15v.01a102.356 102.356 0 005.75 8.66 47.722 47.722 0 0011.4 11.46 30.09 30.09 0 0011.98 4.63c.8.15 1.62.26 2.45.36 3.31.39 6.73.54 10.01 1.24a21.849 21.849 0 014.82 1.55c5.28 2.45 8.25 7.58 9.55 13.06.23.96.41 1.93.55 2.9 1.09 7.45-.11 15.19.51 22.65.07.79.16 1.59.27 2.38h.74l.48-1.1v-.01c-.05-.42-.09-.84-.13-1.27a96.293 96.293 0 01-.09-11.01c.04-1.65.07-3.31.05-4.97-.02-1.33-.07-2.66-.17-3.98v-.01c-.07-.82-.15-1.63-.26-2.44a31.586 31.586 0 00-1.82-7.25 18.152 18.152 0 00-10.32-10.68 27 27 0 00-4.47-1.25c-3.35-.64-6.81-.8-10.18-1.22-.36-.04-.72-.09-1.07-.15-.45-.07-.89-.15-1.33-.23a28.667 28.667 0 01-12.16-5.27 51.9 51.9 0 01-10.98-11.92c-1.64-2.35-3.2-4.75-4.65-7.22a.01.01 0 000-.007.01.01 0 00-.007 0c-.07-.12-.14-.23-.21-.35l-.01-.02a119.57 119.57 0 01-13.46-34.17c-.09-.44-.19-.88-.29-1.32a120.886 120.886 0 01-2.67-26.4v-.01c0-.42.01-.83.02-1.25.02-.86-1.31-1.05-1.33-.19-.01.42-.02.84-.01 1.26a.01.01 0 00-.01.01z",
  fill: "#fff"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 603",
  d: "M26.146 438.583a18.018 18.018 0 01-22.694-5.416c-.509-.7.554-1.523 1.064-.822a16.684 16.684 0 0021.121 4.995c.768-.396 1.273.85.509 1.243z",
  fill: "#fff"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 604",
  d: "M54.166 462.583a34.729 34.729 0 00-1.23-25.279c-.355-.79.889-1.3 1.244-.51a36.123 36.123 0 011.226 26.308c-.279.82-1.517.3-1.24-.519z",
  fill: "#fff"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 605",
  d: "M12.138 402.027a10.2 10.2 0 007.022-6.659c.268-.824 1.506-.3 1.24.519a11.429 11.429 0 01-7.752 7.384.7.7 0 01-.877-.367.675.675 0 01.367-.877z",
  fill: "#fff"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 606",
  d: "M64.205 442.534v.01a131.245 131.245 0 002.67 21.24v.01c.08.48.19.95.29 1.42a184.5 184.5 0 0010.11 31.61q1.785 4.32 3.74 8.55c.36.8.73 1.59 1.11 2.38h1.48l.48-1.1v-.01l.56-1.27.07-.15.03.15.55 2.38h14.3l2.78-2.38 4.05-3.47-5.66-6.18-.93-1.02-.14-.15-.45-.49 1.87-8.18-3.76-.62 4.12-12.71 1.95-6.01.49-1.51 2.85-8.79 8.6 1.61 1.4-4.9a135.993 135.993 0 01-6.42-18.41c-.01-.05-.03-.09-.04-.14a141.582 141.582 0 01-4.02-51.96v-.01c.06-.56.13-1.13.21-1.68v-.02a133.635 133.635 0 014.32-21.34c.14-.53.3-1.05.45-1.57-.46.2-.91.39-1.37.59l-.01.01h-.02c-.73.32-1.46.66-2.17 1.02-17.06 8.29-29.61 23.85-36.74 41.79-.02.05-.04.09-.06.14a96.394 96.394 0 00-6.57 29.43 114.859 114.859 0 00-.12 11.73z",
  fill: "#f0f0f0"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 607",
  d: "M90.155 507.754h1.58c.5-.81 1.04-1.6 1.58-2.38q1.29-1.815 2.66-3.55c.79-1 1.58-1.99 2.37-2.98.82-1.03 1.63-2.06 2.42-3.12l-.93-1.02c-.15.2-.3.4-.46.6-2.56 3.37-5.33 6.61-7.7 10.07-.53.78-1.04 1.57-1.52 2.38z",
  fill: "#fff"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 608",
  d: "M111.597 358.383c-.26.33-.53.67-.78 1.01q-2.925 3.795-5.53 7.83a117.987 117.987 0 00-8.22 14.85c-.19.4-.38.81-.56 1.22a119.264 119.264 0 00-9.84 35.44c-.02.12-.03.23-.04.35q-.495 4.29-.64 8.61a51.782 51.782 0 001.59 16.12c.2.69.42 1.37.66 2.03a27.345 27.345 0 002.25 4.65 27.92 27.92 0 002.14 3.09c.47.6.96 1.19 1.48 1.76.3.33.61.66.92.99.26.25.51.51.77.76 2.7 2.62 5.68 5.05 8.12 7.94l-.49 1.51c-2.35-2.98-5.38-5.45-8.11-8.05a37.9 37.9 0 01-4.66-5.28c-.18-.26-.37-.52-.54-.79a26.751 26.751 0 01-2.39-4.29c-.34-.75-.65-1.52-.93-2.32a47.893 47.893 0 01-2.2-16 103.408 103.408 0 01.62-10.39c.04-.45.09-.89.15-1.34a122.588 122.588 0 0119.28-52.32q2.475-3.765 5.25-7.35c.24-.33.49-.65.75-.98.53-.68 1.48.27.95.95z",
  fill: "#fff"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 609",
  d: "M85.843 419.549a18.018 18.018 0 01-14.86-17.987.673.673 0 011.344-.016 16.684 16.684 0 0013.857 16.7c.852.147.506 1.447-.341 1.3z",
  fill: "#fff"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 610",
  d: "M93.766 455.577a34.729 34.729 0 0014.238-20.924c.192-.844 1.492-.5 1.3.341a36.123 36.123 0 01-14.86 21.743c-.716.488-1.39-.676-.678-1.161z",
  fill: "#fff"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 611",
  d: "M96.668 381.928a10.2 10.2 0 009.616-1.089c.71-.5 1.383.668.678 1.161a11.429 11.429 0 01-10.636 1.228.7.7 0 01-.479-.821.675.675 0 01.821-.479z",
  fill: "#fff"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 612",
  d: "M186.082 487.193h10.2l4.854-39.351H186.08z",
  fill: "#ffb8b8"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 613",
  d: "M182.627 482.16l16.128-.963v6.91l15.328 10.589a4.316 4.316 0 01-2.453 7.868h-19.2l-3.309-6.835-1.292 6.835h-7.239z",
  fill: "#2f2e41"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 614",
  d: "M89.657 482.117l9.971 2.162 13.085-37.428L98 443.66z",
  fill: "#ffb8b8"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 615",
  d: "M87.348 476.466l15.965 2.478-1.465 6.753 12.735 13.599a4.316 4.316 0 01-4.065 7.169l-18.764-4.071-1.785-7.381-2.712 6.406-7.075-1.535z",
  fill: "#2f2e41"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 616",
  d: "M17.805 506.564a1.186 1.186 0 001.19 1.19h280.288a1.19 1.19 0 100-2.38H18.995a1.186 1.186 0 00-1.19 1.19z",
  fill: "#ccc"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 617",
  d: "M217.698 311.411c-7.16 39.35-8.95 56.34-8.95 56.34s5.37 6.26 1.79 9.84 0 10.73 0 10.73l-9.372 74.838-2 11-18.768-2.648 2.768-10.352-4.818-71.938s-3.58-7.16-1.79-8.95-1.79-12.52-1.79-12.52l-4.47-84.96-27.73 93.01s2.69 3.58 0 6.26-8.04 16.1-8.04 16.1l-20.362 54-4 8-2.128-1.008-9.36-1.76-1.72-.32-3.06-.58-1.97-.37-.67-.12-3.24-.61.98-4.35 7.168-10.882 7.292-53.368.32-1.43.34-1.51s-1.79-4.47.89-7.16a6.988 6.988 0 001.79-6.26 2.437 2.437 0 01-.24-.3 3.713 3.713 0 01-.64-1.46c-.24-1.12-.03-2.69 1.78-4.5a7.635 7.635 0 001.27-1.82c2.72-5.15 4.09-16.06 4.09-16.06s2.42-86.41 10.34-99.61c.42-.69 8.828-13.936 9.268-14.207 8.94-5.36 78.714 1.043 78.714 1.043s4.219 11.333 4.409 12.513c1.029 6.629 7.979 31.999 1.909 65.379z",
  fill: "#2f2e41"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 618",
  d: "M290.102 119.299a8.566 8.566 0 01-11.049 7.1l-18.088 24.485-5.448-14.851 18.012-20.975a8.613 8.613 0 0116.572 4.237z",
  fill: "#ffb8b8"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 619",
  d: "M125.06 223.014c-1.658 0-2.6-.325-2.965-1.022-.535-1.023.394-2.36 1.469-3.909a11.959 11.959 0 001.863-3.356c.643-2.572 4.983-67.547 2.387-80.529-.6-3-.083-6.854 1.536-11.444 4.424-12.535 10.463-16.388 22.494-24.062q1.465-.935 3.051-1.952c1.368-.879 1.292-3.793 1.211-6.879-.089-3.43-.182-6.977 1.5-9.193l.109-.145.176-.041c4.064-.939 17.732-2.684 25.827.013l.112.038.083.083c1.923 1.923 2.1 5.647 2.268 9.249.139 2.957.27 5.749 1.358 6.962 8.317 9.271 17.75 9.09 17.845 9.088l.467-.014.046.465c3 30.469-3.8 61.875-5.368 78.387-19.1-9.485-.213-4.106 0-3.73.132.2 1.57 20.33 1.45 20.542-1.819 3.398-70.669 21.449-76.919 21.449zm80.323-21.45h.514",
  fill: "#6cbbed"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 85",
  cx: 24.667,
  cy: 24.667,
  r: 24.667,
  transform: "translate(154.716 20.73)",
  fill: "#ffb8b8"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 620",
  d: "M195.865 90.488c-1.169-1.67-7.1-22.067-9.7-28.328-.266 1.346-3.246 6.563-3.316 7.951l-.026.514-.511.066c-.768.1-18.911 2.3-28.352-8.406-5.594-6.342-6.863-15.854-3.776-28.278a4.924 4.924 0 01-1.59-.612 6.827 6.827 0 01-2.91-4.958l-.523.14c-2.662.718-5.665 1.669-7.6 3.862-2.159 2.44-2.544 5.755-2.952 9.264a40.039 40.039 0 01-.791 4.981c-1.315 5.307-5.019 10.278-11.007 14.775-6.029 4.527-12.176 7.118-18.27 7.7-7.2.687-14.14-1.678-18.564-6.321-4.933-5.177-6.223-13.141-3.069-18.937l.508-.934.558.9c2.808 4.557 8.943 7.018 14.921 5.984 5.126-.887 10.207-4.141 14.309-9.164 3.744-4.585 6.326-10 8.823-15.238 2.54-5.325 5.166-10.832 8.949-15.5 4.267-5.27 9.592-8.712 14.995-9.693 3.934-.711 7.445.1 9.634 2.216a9.175 9.175 0 012.578 5.905 7.413 7.413 0 014.051.233 7.516 7.516 0 014.639 6.149c7.927-4.17 18.419-3.491 23.845-.363 2.272 1.31 3.577 2.96 3.808 4.8 6.409.358 13.3 6.6 13.3 15.446v.616h-.616c-5.072 0-9.7 2.917-12.388 7.8a18.119 18.119 0 00.557 18.487 26.068 26.068 0 013.6 19.931l-2.315 10.142z",
  fill: "#2f2e41"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 621",
  d: "M224.183 182.742l-16.26-9.146c-28.354-19.653-35.339-35.261-36.212-44.9-.932-10.282 4.546-15.906 4.78-16.14l.126-.093 14.656-7.486a14.752 14.752 0 0120.576 8.1l13.558 37.288 15.032-11.088 6.411-2.526 5.173-6.917 14.207-8.286 10.554 9.5-13.273 26.539-7.374 1.878-1.564 4.028-.139.089z",
  fill: "#6cbbed"
})));
export default SvgUndrawConnect;